import { LitElement, html, svg } from 'lit';

export class IconBell24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Bjelle</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.01 21.782a2.107 2.107 0 0 0 1.992 1.467c.905 0 1.725-.605 1.993-1.467M12 3V.75M12 3c4.168 0 7.5 3.492 7.5 7.619C19.5 17.777 21 19 21 19H3s1.5-1.946 1.5-8.381C4.5 6.519 7.865 3 12 3Z"></path></svg>`; }
}
if (!customElements.get('f-icon-bell24', IconBell24)) {
  customElements.define('f-icon-bell24', IconBell24);
}